import { PageTitle, useLanguageCode } from '@procureai/ui-mui';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';

interface CmdiEntity {
  id: string;
  name: string;
  i18n: any;
}

export interface CmdiPageTitleProps {
  selectedEntity?: CmdiEntity;
}

export const CmdiPageTitle = ({ selectedEntity }: CmdiPageTitleProps) => {
  const { t } = useTranslation();
  const { languageCode } = useLanguageCode();
  const languageCodeUpper = languageCode.toUpperCase();

  const title = selectedEntity ? (selectedEntity?.i18n[languageCodeUpper] ?? '') : t(`Cmdi.common.title`);

  return (
    <>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      <PageTitle title={title} />
    </>
  );
};
